if (!customElements.get('collage-mobile-carousel')) {
  class CollageMobileCarousel extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[id^="shopify-section-"]');
      this.grid = this.section.querySelector('.collage-desktop-grid');
      this.sliderElement = this.querySelector('.keen-slider');
      this.dots = this.querySelector('.keen-dots');
      this.items = [];
      this.itemLocations = [];
      this.onMediaChange = this.sync.bind(this);
      window.addEventListener('mediaChange', this.onMediaChange);
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('mediaChange', this.onMediaChange);
      this.destroy();
    }

    sync() {
      if ($s.media.isLarge) {
        this.destroy();
      } else {
        const itemsPerView = this.getItemsPerView();
        if (!this.sliderObj) {
          this.init(itemsPerView);
        } else if (this.itemsPerView !== itemsPerView) {
          this.destroy();
          this.init(itemsPerView);
        }
      }
    }

    getItemsPerView() {
      const tabletItemsPerView = parseFloat(this.dataset.itemsPerViewTablet);
      if (!$s.media.isSmall && tabletItemsPerView > 0) return tabletItemsPerView;
      return parseFloat(this.dataset.itemsPerView);
    }

    init(itemsPerView) {
      if (typeof KeenSlider !== 'function') return;
      this.items = Array.from(this.grid.querySelectorAll('.collage-item')).sort((itemA, itemB) => {
        return Number(itemA.dataset.collageOrder) - Number(itemB.dataset.collageOrder);
      });
      this.itemLocations = this.items.map((item) => {
        const placeholder = document.createComment('collage-mobile-carousel-item');
        item.parentNode.insertBefore(placeholder, item);
        return {item, placeholder};
      });
      try {
        this.itemLocations.forEach(({item}) => {
          item.classList.add('keen-slider-slide');
          this.sliderElement.appendChild(item);
        });
        const config = {
          mode: 'snap',
          centered: this.classList.contains('collage-mobile-carousel--full'),
          loop: this.classList.contains('collage-mobile-carousel--full'),
          slidesPerView: itemsPerView,
          spacing: parseFloat(getComputedStyle(this.section).getPropertyValue('--items-spacing')) || 0
        };
        if (this.dots) config.dots = this.dots;
        this.sliderObj = new KeenSlider(this.sliderElement, config);
        this.itemsPerView = itemsPerView;
        this.section.classList.add('mobile-carousel-active');
        this.addMobileListeners();
      } catch (error) {
        try {
          if (this.sliderObj) this.sliderObj.destroy();
        } catch (destroyError) {
          this.sliderObj = null;
        }
        this.sliderObj = null;
        this.itemsPerView = null;
        this.removeMobileListeners();
        this.restoreItems();
        this.clearItemLocations();
      }
    }

    destroy() {
      this.removeMobileListeners();
      try {
        if (this.sliderObj) this.sliderObj.destroy();
      } catch (error) {
        this.sliderObj = null;
        this.itemsPerView = null;
      } finally {
        this.sliderObj = null;
        this.itemsPerView = null;
        this.restoreItems();
        this.clearItemLocations();
      }
    }

    restoreItems() {
      this.itemLocations.forEach(({item, placeholder}) => {
        if (placeholder.parentNode) placeholder.parentNode.insertBefore(item, placeholder);
        item.classList.remove('keen-slider-slide');
      });
      this.section.classList.remove('mobile-carousel-active');
    }

    clearItemLocations() {
      this.itemLocations.forEach(({placeholder}) => placeholder.remove());
      this.items = [];
      this.itemLocations = [];
    }

    addMobileListeners() {
      this.onKeyDown = (event) => {
        if (!(event.target instanceof Element) || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        if (event.target.closest('input, textarea, select, [contenteditable]')) event.stopImmediatePropagation();
      };
      this.addEventListener('keydown', this.onKeyDown, true);
      if (window.Shopify && Shopify.designMode) {
        this.onBlockSelect = (event) => {
          const index = this.items.indexOf(event.target);
          if (index >= 0 && this.sliderObj) this.sliderObj.moveToSlideRelative(index, true, 0);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      if (this.dots) {
        this.dotObserver = new MutationObserver(() => this.updateDotState());
        this.dotObserver.observe(this.dots, {attributes: true, attributeFilter: ['class'], childList: true, subtree: true});
        this.updateDotState();
      }
    }

    removeMobileListeners() {
      if (this.onKeyDown) this.removeEventListener('keydown', this.onKeyDown, true);
      if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.dotObserver) this.dotObserver.disconnect();
      this.onKeyDown = null;
      this.onBlockSelect = null;
      this.dotObserver = null;
    }

    updateDotState() {
      this.dots.querySelectorAll('.keen-dots-dot').forEach((dot) => {
        dot.setAttribute('aria-current', dot.classList.contains('active') ? 'true' : 'false');
      });
    }
  }

  customElements.define('collage-mobile-carousel', CollageMobileCarousel);
}
